import React from 'react';
import PropTypes from 'prop-types';
import AntdProForm, { ProFormSelect } from '@ant-design/pro-form';
import { gql, useQuery } from '@apollo/client';
import ProForm from '../../layout/ProForm';
import { getValueEnumFromData, formatEnum } from '../../../utils';

const GET_OPTIONS_TAB_REPORT_SETTINGS = gql`
  query GET_OPTIONS_TAB_REPORT_SETTINGS {
    reportType: __type(name: "ReportType") {
      enumValues {
        name
      }
    }
    reportForm: __type(name: "ReportForm") {
      enumValues {
        name
      }
    }
  }
`;

const reportFormValueEnum = getValueEnumFromData('reportForm', false);

const ReportSettingsForm = ({ onFinish, initialValues }) => {
  const [form] = AntdProForm.useForm();
  const { data, loading } = useQuery(GET_OPTIONS_TAB_REPORT_SETTINGS);

  return (
    !loading && (
      <ProForm
        form={form}
        onFinish={onFinish}
        initialValues={initialValues}
        backPage="/system-setting/project-categories"
      >
        {data.reportType.enumValues.map(({ name }) => (
          <ProFormSelect
            label={formatEnum(name)}
            name={name}
            key={name}
            width="xl"
            placeholder="select"
            valueEnum={data ? reportFormValueEnum(data) : {}}
            rules={[
              {
                required: true,
                message: 'please select',
              },
            ]}
          />
        ))}
      </ProForm>
    )
  );
};

ReportSettingsForm.defaultProps = {
  initialValues: {},
};

ReportSettingsForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    reportSettings: PropTypes.arrayOf(
      PropTypes.shape({
        reportType: PropTypes.string,
        reportForm: PropTypes.string,
      })
    ),
  }).isRequired,
};

export default ReportSettingsForm;
